document.addEventListener("DOMContentLoaded", code);
if (window.acf) {
    window.acf.addAction("render_block_preview/type=accordion", code);
}

function code(event) {
    document.addEventListener(
        "click",
        function (event) {

            // If the clicked element isn't the to accordion trigger, return
            if (!event.target.matches(".accordion-trigger")) {
                return;
            }

            //fetch all open FAQs
            let all_open = document.getElementsByClassName("accordion-open");

            //if we have some open FAQs
            if (all_open) {
                //loop over the FAQs
                for (let i = 0; i < all_open.length; i++) {
                    //remove the open class
                    all_open[i].classList.remove("accordion-open");
                }
            }

            //add the open class
            event.target.classList.toggle("accordion-open");
        },
        false
    );
}